import React from 'react';
import { ICollection, IContent } from 'types';
import { CSSObject } from '@emotion/react';
import CollectionTitle from './CollectionTitle';

interface Props {
  collection: ICollection;
}

const gridStyle: CSSObject = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px 8px',
};

const thumbnailStyle: CSSObject = {
  aspectRatio: '1/1',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

const contentInfoStyle: CSSObject = {
  marginTop: '8px',

  '& .subTitle': {
    fontSize: '14px',
    color: '#90929A',
    marginBottom: '4px',
  },

  '& .title': {
    fontSize: '16px',
    fontWeight: 'bold',
  },
};

function GridCollection({ collection }: Props) {
  return (
    <div css={{ padding: '16px' }}>
      <CollectionTitle title={collection.title} />
      <div css={gridStyle}>
        {collection.contents?.map((c) => {
          const content = c as IContent;
          return (
            <div key={content.id}>
              <div css={thumbnailStyle}>
                <img src={content.thumbnailUrl} alt={content.title} />
              </div>
              <div css={contentInfoStyle}>
                <div className="subTitle">{content.subTitle}</div>
                <div className="title">{content.title}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GridCollection;
